export const GET_ALL_PATIENTS = 'GET_ALL_PATIENTS';
export const FAILED_TO_GET_ALL_PATIENTS = 'FAILED_TO_GET_ALL_PATIENTS'
export const ADD_PATIENTS = 'ADD_PATIENTS'